module.exports = __webpack_public_path__ + "static/media/portal_down.0bac467b.gif";